<template>
<div class="chapter">
<div class="inner_page">
<div class="halfTitlePage" id="hft01">
<h2 class="halfTitlePageTitle"><span class="bold">CONFEDERATE GOLD</span></h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312943349_hft01.vue?05cb1ffe